/**
 * Private modules
 */
const {
  createQueryComponent,
  customerId,
  drawId,
  systemGameId,
} = require('../.private').components;

module.exports = {
  getDrawSystemGameCreditByCustomerId: {
    properties: {
      params: {
        properties: {
          customerId,
          drawId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
          'drawId',
        ],
        type: 'object',
      },
      query: createQueryComponent(),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  getDrawSystemGameCredits: {
    properties: {
      params: {
        properties: {
          drawId,
          systemGameId,
        },
        required: [
          'systemGameId',
          'drawId',
        ],
        type: 'object',
      },
      query: createQueryComponent(),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
};
